<div class="container">
    <div class="col-md-12 lease_table ">
        <div class="">
            <div class="main">
                <div class="heading mb-3">

                    <div class="migration_detials">All India Score Registration
                    </div>
                </div>

                <div class="context">
                    <form [formGroup]="Scoreform">
                        <div class="row col-md-12 mb-4">
                          <div class="col-md-6">
                            <input formControlName="mobile" type="text" class="form-control" placeholder="Mobile Number">
                          </div>
                          <div class="col-md-6">
                            <input formControlName="whatsappMobile" type="text" class="form-control" placeholder="Whatsapp's Mobile Number">
                          </div>
                        </div>
                      
                        <div class="row col-md-12 mb-4">
                          <div class="col-md-6">
                            <input formControlName="firstName" type="text" class="form-control" placeholder="First Name">
                          </div>
                          <div class="col-md-6">
                            <input formControlName="lastName" type="text" class="form-control" placeholder="Last Name">
                          </div>
                        </div>
                      
                        <div class="row col-md-12 mb-4">
                          <div class="col-md-6">
                            <select formControlName="ambitionStream" class="form-select">
                              <option value="0">Select Ambition Stream</option>
                              <option value="1">M.P.C</option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <select formControlName="isChaithanyaStudent" class="form-select">
                              <option value="0">Are you a Sri Chaithanya student?</option>
                              <option value="1">Yes</option>
                              <option value="2">No</option>
                            </select>
                          </div>
                        </div>
                      
                        <div class="row col-md-12 mb-4">
                          <div class="col-md-6">
                            <select formControlName="grade" class="form-select">
                              <option value="0">Select Grade</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <select formControlName="targetExam" class="form-select">
                              <option value="0">Select Target Exam</option>
                              <option value="1">Foundation Test</option>
                              <option value="2">Aptitude</option>
                            </select>
                          </div>
                        </div>
                      
                        <div class="row col-md-12 mb-4">
                          <div class="col-md-6">
                            <select formControlName="state" class="form-select">
                              <option value="0">Select State</option>
                              <option value="1">Andhra Pradesh</option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <select formControlName="district" class="form-select">
                              <option value="0">Select District</option>
                              <option value="1">Guntur</option>
                              <option value="2">Nellore</option>
                            </select>
                          </div>
                        </div>
                      
                        <div class="row col-md-12 mb-4">
                          <div class="col-md-6">
                            <select formControlName="city" class="form-select">
                              <option value="0">Select City</option>
                              <option value="1">Nellore</option>
                              <option value="2">Guntur</option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <select formControlName="examMode" class="form-select" (change)="onModeChange()">
                              <option value="0">Select Mode of Exam</option>
                              <option value="1">Online</option>
                              <option value="2">Offline</option>
                            </select>
                          </div>
                        </div>
                      
                        <!-- Conditional Inputs -->
                        <div *ngIf="Scoreform.get('examMode')?.value === '1'" class="col-md-6 mt-2">
                          <input formControlName="onlineExamLink" type="text" class="form-control" placeholder="Enter Online Exam Link">
                        </div>
                      
                        <div *ngIf="Scoreform.get('examMode')?.value === '2'" class="col-md-6 mt-2">
                          <input formControlName="examCenterName" type="text" class="form-control mb-2" placeholder="Enter Exam Center Name">
                          <input formControlName="examRoomNumber" type="text" class="form-control" placeholder="Enter Exam Room Number">
                        </div>
                        <div>
                            <div  class="col-md-12 mt-2">
                                <input formControlName="onlineExamLink" type="text" class="form-control" placeholder="Enter Online Exam Link">
                              </div>
                              <div  class="col-md-12 mt-2">
                                <input formControlName="onlineExamLink" type="text" class="form-control" placeholder="Enter Online Exam Link">
                              </div>
                              <div  class="col-md-12 mt-2">
                                <input formControlName="onlineExamLink" type="text" class="form-control" placeholder="Enter Online Exam Link">
                              </div>
                        </div>
                      </form>
                      
            </div>
        </div>
        <div class="col-lg-12 text-center mt-3">
            <button class="btn btn-primary" routerLink="/score">Submit</button>
        </div>

    </div>
</div>
</div>